import { maxBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const list = css`
  margin: 0;
  padding: 0;
  list-style: none;
  grid-column: span 12;
  display: flex;
  flex-wrap: wrap;
  column-gap: ${spacing.xs}px;
  row-gap: ${spacing.xs}px;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      padding-left: ${spacing.md}px;
      padding-right: ${spacing.md}px;
    `,
  )}

  a {
    ${responsiveText.BODY.SM};
    cursor: pointer;
    text-decoration: none;

    & > span {
      display: inline-block;
      height: 16px;
      width: 16px;
    }
  }
`;

export const resetFacetButton = css`
  border: 1px solid color-mix(in srgb, ${palette.deepPurpleBase} 70%, white);
  border-radius: ${spacing.base}px;
  display: inline-flex;
  align-items: center;
  gap: ${spacing.xs}px;
  padding: ${spacing.xs}px;
  background-color: color-mix(in srgb, ${palette.deepPurpleBase} 10%, white);
  color: ${palette.deepPurpleBase};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  font-family: ${fonts.PRIMARY_REGULAR.family};
`;

export const resetAllButton = css`
  display: inline-flex;
  padding: ${spacing.xs}px 0;
  background-color: transparent;
  color: ${palette.deepPurpleBase};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
`;
